import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DataChangeNotification} from '../../../../../services/signalR/signalRService';

@Component({
  selector: 'jacking-external-change-notification',
  templateUrl: 'jacking-external-change-notification.component.html'
})
export class JackingExternalChangeNotificationComponent {
  @Input() loading = false;
  @Input() pending = false;
  @Input() notification: DataChangeNotification | null = null;
  @Input() hasLocalEdits = false;
  @Input() reviewing = false;
  @Input() reviewError = '';
  @Input() resultMessage = '';
  @Input() resultTitle = '';
  @Output() actionRequested = new EventEmitter<void>();

  get changeDescription(): string {
    return String(this.notification?.changeType || 'updated').toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-external-change-notification/jacking-external-change-notification.component.ts